'use client';

import React from 'react';
import './TabDescription.scss';

interface TabDescriptionProps {
  detail: {
    show_description?: string;
  };
}

const TabDescription: React.FC<TabDescriptionProps> = ({ detail }) => {
  return (
    <div className="bg-[#f4f4f4] py-[3.75vw] px-[10.41vw] rounded-[4px] mt-[1.67vw] flex justify-center items-center">
      <div
        className="w-[29.17vw] mt-[16px] font-ir text-[14px] leading-[22px] goods-description"
        dangerouslySetInnerHTML={{ __html: detail.show_description || '' }}
      />
    </div>
  );
};

export default TabDescription;
